import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Home from '../views/Admin.vue'
import Login from '../views/Login.vue'
import Manager from '../views/Manager.vue'

// const routes = [
//   // {
//   //   path: '/',
//   //   name: 'Home',
//   //   component: Home
//   // },
//   {
//     path: '/login',
//     name: 'Login',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
//   },
//    {
//     path: '/manager',
//     name: 'Manager',
//     component: Manager,
//     children:[
//       {path:'home', component: () => import('../views/Home.vue')}
//     ]
//   },
// ]

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes:[
    {path: '/',redirect:'/manager/home'},
    {path: '/manager',component: () => import('../views/Manager.vue'),
      children:[
        {path:'home',meta:{name:'主页'}, component: () => import('../views/Home.vue'),},
        {path:'admin',meta:{name:'数据信息'}, component: () => import('../views/Admin.vue'),},
        {path:'user',meta:{name:'用户信息'}, component: () => import('../views/User.vue'),},
        {path:'person',meta:{name:'个人中心'}, component: () => import('../views/Person.vue'),},
        {path:'updatePassword',meta:{name:'修改密码'}, component: () => import('../views/UpdatePassword.vue'),},
        {path:'userData',meta:{name:'数据信息'}, component: () => import('../views/UserData.vue'),},
        

      ]
    },
    {path:'/login', component:  () =>import('../views/Login.vue'),},
	{path:'/UserData01', component:  () =>import('../views/UserData01.vue'),},


  ]
})

export default router







// https://s-siti.com/api/files/download/ceshi.xlsx


// https://s-siti.com/api/files/download/1759930213304-999.jpg


// https://s-siti.com/api/files/1759930621404-999.jpg


// Shjm@op1236540

// shop@1236540




// 6,204.650   




const submit1 = ()=> {
	baseForm1.value.validate().then(res => {
		
		uni.uploadFile({
								url: 'https://s-siti.com/api/user01/add02', //仅为示例，非真实的接口地址
								// filePath: baseFormData.fileurl,
								name: 'file',
								formData: {
									'name': baseFormData.name,
									'phone':baseFormData.phone,
									'address':baseFormData.address
								},
								// header:{
								// 	'Content-Type': 'application/x-www-form-urlencoded'
								// },
								success: (res) => {
									console.log('1234',res.data);
									
									 uni.showModal({
									       title: '提交完成',
									       confirmText: '确定'
									     });
										 resetForm(); // 提交成功后调用重置函数
									
									 
								},
								fail:(res) => {
									console.log(res)
									uni.showModal({
									   title: '提交失败',
									   confirmText: '确定'
									 });
								}
							});
	}).catch(err => {
		console.log('err');
	})
}